var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CagButton',{staticClass:"user-menu-button",attrs:{"no-border":""},nativeOn:{"click":function($event){return _vm.goToRoute(_vm.routeName)}}},[_c('IconBase',{key:_vm.iconName,staticClass:"icon",attrs:{"icon-name":_vm.iconName,"aria-hidden":"true"}}),_c('span',{staticClass:"label"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }